import React from "react";
import "./Loader1.css";
function Loader() {
  return (
    <div className={`flex justify-center items-center h-screen mx-auto `}>
      <div className="loader "></div>
    </div>
  );
}

export default Loader;
